<template>
  <div>
    <slot name="additional-header" />
    <b-row>
      <b-col>
        <p class="description">{{ $t('permissions.android.modal.description') }}</p>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <div class="d-flex align-items-center mb-4">
          <sdui-icon variant="primary"
                     bg-variant="primary"
                     class="sdui-icon md mr-2 icon-privacy-o"
          />
          <p class="mb-0">{{ $t(`permissions.android.${requestedPermission}`) }}</p>
        </div>
        <slot name="additional-content" />
        <slot name="additional-action" />
      </b-col>
    </b-row>

    <SModalPortalTo>
      <b-button size="lg"
                block
                variant="primary"
                @click="$emit('close')"
      >
        {{ $t('ui.info_modal.cancel') }}
      </b-button>
    </SModalPortalTo>
  </div>
</template>

<script>
import SModalPortalTo from 'src/components/base/SModal/SModalPortalTo.vue'

export default {
  name: 'PermissionModal',
  components: { SModalPortalTo },
  props: {
    requestedPermission: {
      type: String,
      required: true,
    },
  },

  emits: ['close'],
}
</script>
